import { useEffect, useState } from 'react';

import { Routes, Route, Router, useNavigate, useLocation } from 'react-router-dom';
//Components
import "./App.css";
import { Localization } from './CustomeComponents/Localization';
import AppHeader from "./Components/AppHeader";
import PageFooter from "./Components/AppFooter";
import TikRishuiRegistration from "./Components/TikRishuiRegistration";
import TikimList from "./Components/TikimList";
import NavBarContainer from "./Components/RishuiBnia/NavBarContainer"
import NavBarTabaContainer from "./Components/Taba/NavBarTabaContainer";
import TikimTaba from "./Components/Taba/TikimTaba";
import TikimPikuahBnia from "./Components/Pikuah/TikimPikuahBnia";
import NavBarPikuahBniaContainer from "./Components/Pikuah/NavBarPikuahBniaContainer";
import NavBarHeytelContainer from "./Components/Heytel/NavBarHeytelContainer";
import NotFoundPage from './CustomeComponents/NotFoundPage';
//API
import { fetchTikRushiData, fetchTikTabaData, fetchTikPikuahBniaData, fetchTikHeytelHashbahaData } from './server/ServerFunc';
// Rishui Bnia:
// import RishuiBniaComponentsRoutesONLY from './Components/RishuiBnia/RishuiBniaComponentsRoutesONLY';
import BakashalInfo from './Components/RishuiBnia/BakashalInfo';
// import ProcessInfo from './Components/RishuiBnia/ProcessInfo';
import ProcessInfoContainer from './Components/RishuiBnia/ProcessInfoContainer';
import VahadaInfo from './Components/RishuiBnia/VahadaInfo';
import LocationInfo from './Components/RishuiBnia/LocationInfo';
import AreasInfo from './Components/RishuiBnia/AreasInfo';
// import TnaimInfo from './Components/RishuiBnia/TnaimInfo';
import TnaimInfoContainer from './Components/RishuiBnia/TnaimInfoContainer';
import ArchivInfo from './Components/RishuiBnia/ArchivInfo';
//Pikuah Bnia:
import PikuahInfo from './Components/Pikuah/PikuahInfo';
//Taba:
import TamztitTabalInfo from './Components/Taba/TamztitTabalInfo';
import TeurInfo from './Components/Taba/TeurInfo';
import HavotDaatInfo from './Components/Taba/HavotDaatInfo';
import YahasTohnitInfo from './Components/Taba/YahasTohnitInfo';
//Heytel Hashbaha:
import ProcessHeytelInfo from './Components/Heytel/ProcessHeytelInfo';
import AppHeaderGlobal from './Components/AppHeaderGlobal';
import AppFooter from './Components/AppFooter';
import ArchivPikuahInfo from './Components/Pikuah/ArchivPikuahInfo';
import HeiterDocuments from './Components/RishuiBnia/HeiterDocuments';


function App() {
  const [tikDataList, setTikDataList] = useState([]);
  const [tabaDataList, setTabaList] = useState([]);
  const [pikuahBniaList, setPikuahBniaList] = useState([]);
  const [pageEvent, setPageEvent] = useState("");
  
  const search = useLocation().search;
  const navigate = useNavigate();
  
  useEffect(() => {
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    switch (systemCodeURL) {
      case "26400046":
        document.title = "איתור תיק רישוי בניה";
        break;
      case "26400056":
          document.title = "איתור תיק פיקוח בניה";
          break;
      case "26400001":
        document.title = "איתור תיק תב''ע";
        break;
      case "26400016":
          document.title = "איתור תיק היטל השבחה";
          break;
      default:
        break;
    }
  }, []);

  const handleSearchTikRishui = async (dataToSerach, page = "") => {
    const dataTikList = await fetchTikRushiData(dataToSerach);
    if(dataTikList.length > 0) {
      setTikDataList(dataTikList);
      if(dataTikList.length === 1) {
        if(page === "Header") {
          setPageEvent(page)
        }
        navigate(`/Details?TikNum=${dataTikList[0].tik_num}&SystemCode=${dataToSerach.systemId}&Page=BakashalInfo`);
      } else {
        localStorage.setItem('detailsForTitle', JSON.stringify({ detailsForTitle: dataToSerach }));
        navigate(`/TableData?TikNum=${0}&SystemCode=${dataToSerach.systemId}`);
      }
    } else {
      // alert("התרחשה שגיאה או שאין מידע, נסה שוב");
      alert("לא נמצא מידע");
    }
  }

  const handleSearchTaba = async (tabaToSearch, page = "") => {
    const dataTabaList = await fetchTikTabaData(tabaToSearch);
    if(dataTabaList.length > 0) {
      setTabaList(dataTabaList);
      if(dataTabaList.length === 1) {
        if(page === "Header") {
          setPageEvent(page);
        }
        navigate(`/TabaDetails?TikNum=${dataTabaList[0].tohnit}&SystemCode=${tabaToSearch.systemId}&Page=TamztitTabalInfo`);
      } else {
        localStorage.setItem('detailsForTitle', JSON.stringify({ detailsForTitle: tabaToSearch }));
        navigate(`/TikimTaba?TikNum=${0}&SystemCode=${tabaToSearch.systemId}`);
      }
    } else {
      // alert("התרחשה שגיאה או שאין מידע, נסה שוב");
      alert("לא נמצא מידע");
    }
  }

  const handleSearchPikuahBnia = async (pikuahToSearch, page = "") => {
    const pikuahDataList = await fetchTikPikuahBniaData(pikuahToSearch);
    if(pikuahDataList.length > 0) {
      setPikuahBniaList(pikuahDataList);
      if(pikuahDataList.length === 1) {
        if(page === "Header") {
          setPageEvent(page);
        }
        navigate(`/PikuahBniaDetails?TikNum=${pikuahDataList[0].tikNum}&SystemCode=${pikuahToSearch.systemId}&Page=ProcessInfo`);
      } else {
        localStorage.setItem('detailsForTitle', JSON.stringify({ detailsForTitle: pikuahToSearch }));
        navigate(`/TikimPikuahBnia?TikNum=${0}&SystemCode=${pikuahToSearch.systemId}`);
      }
    } else {
      // alert("התרחשה שגיאה או שאין מידע, נסה שוב");
      alert("לא נמצא מידע");
    }
  }

  const handleSearchHeytelHashbaha = async (heytelHashbahaToSearch, page = "") => {
    const heytelData = await fetchTikHeytelHashbahaData(heytelHashbahaToSearch);
    if(heytelData.countRecord > 0) {
      if(heytelData.countRecord > 1) {
        alert("לא נמצא תיק, אנא הכנס מספר תיק ושנה ספציפיים");
      } else {
        if(page === "Header") {
          setPageEvent(page)
        }
        navigate(`/HeytelHashbahaDetails?TikNum=${heytelData.tikId}&SystemCode=26400016&Page=ProcessInfo`);
      }
    } else {
      if(page === "Header") {
        // alert("התרחשה שגיאה או שאין מידע, נסה שוב");
        alert("לא נמצא מידע");
      } else {
        alert("לא נמצא תיק, אנא נסה מספר תיק / אסמכתא / טופס אחר")
      }
    }
  }

  // const NotFound = () => {
  //   return (
  //     <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
  //   )
  // }

  const MainContainerRoutesWithLayout = () => (
      <div>
        <AppHeader handleRishuiSearch={handleSearchTikRishui} searchTaba={handleSearchTaba} searchTikPikuah={handleSearchPikuahBnia} seacrhHeytel={handleSearchHeytelHashbaha} />
        <Routes>
            <Route path='/' element={<TikRishuiRegistration handleRishuiSearch={handleSearchTikRishui} searchTaba={handleSearchTaba} searchTikPikuah={handleSearchPikuahBnia} seacrhHeytel={handleSearchHeytelHashbaha} />} />
            <Route path='/TableData' element={<TikimList tikData={tikDataList} />} />
            <Route path='/Details' element={<NavBarContainer pageEvent={pageEvent} />} />
            <Route path='/TikimTaba' element={<TikimTaba tabaData={tabaDataList} />} />
            <Route path='/TabaDetails' element={<NavBarTabaContainer pageEvent={pageEvent} />} />
            <Route path='/TikimPikuahBnia' element={<TikimPikuahBnia pikuahBniaData={pikuahBniaList} />} />
            <Route path='/PikuahBniaDetails' element={<NavBarPikuahBniaContainer pageEvent={pageEvent} />} />
            <Route path='/HeytelHashbahaDetails' element={<NavBarHeytelContainer pageEvent={pageEvent} />} />
            <Route element={<NotFoundPage />} />
        </Routes>
        <PageFooter />
      </div>
  );
  
  return (
    <div className="app">
      <Localization>
        <div className="app-body">
          {/* <AppHeaderGlobal /> */}
          <Routes>
            <Route path='/*' element={ <MainContainerRoutesWithLayout /> } />

            {/* Rishui */}
            {/* <Route path='/Rishui' element={ <RishuiBniaComponentsRoutesONLY /> } /> */}
            <Route path='/Rishui/BakashalInfo' element={<BakashalInfo isSeparate={true} />} />
            {/* <Route path='/Rishui/ProcessInfo' element={<ProcessInfo />} />  */}
            <Route path='/Rishui/ProcessInfo' element={<ProcessInfoContainer isSeparate={true} />} /> 
            <Route path='/Rishui/VahadaInfo' element={<VahadaInfo isSeparate={true} />} />
            <Route path='/Rishui/LocationInfo' element={<LocationInfo isSeparate={true} />} />
            <Route path='/Rishui/AreasInfo' element={<AreasInfo isSeparate={true} />} />
            {/* <Route path='/Rishui/TnaimInfo' element={<TnaimInfo />} /> */}
            <Route path='/Rishui/TnaimInfo' element={<TnaimInfoContainer isSeparate={true} />} />
            <Route path='/Rishui/ArchivInfo' element={<ArchivInfo isSeparate={true} />} />
            <Route path='/Rishui/HeiterDocuments' element={<HeiterDocuments isSeparate={true} />} />
            {/* Pikuah */}
            <Route path='/Pikuah/PikuahInfo' element={<PikuahInfo isSeparate={true} />} />
            {/* <Route path='/Pikuah/ProcessInfo' element={<ProcessInfo />} /> */}
            <Route path='/Pikuah/ProcessInfo' element={<ProcessInfoContainer isSeparate={true} />} /> 
            <Route path='/Pikuah/LocationInfo' element={<LocationInfo isSeparate={true} />} />
            <Route path='/Pikuah/BakashalInfo' element={<BakashalInfo isSeparate={true} />} />
            <Route path='/Pikuah/ArchivInfo' element={<ArchivPikuahInfo isSeparate={true} />} />
            
            {/* Taba */}
            {/* <Route path='/Taba/ProcessInfo' element={<ProcessInfo />} /> */}
            <Route path='/Taba/ProcessInfo' element={<ProcessInfoContainer isSeparate={true} />} /> 
            <Route path='/Taba/VahadaInfo' element={<VahadaInfo isSeparate={true} />} />
            <Route path='/Taba/TamztitTabalInfo' element={<TamztitTabalInfo isSeparate={true} />} />
            <Route path='/Taba/ArchivInfo' element={<ArchivInfo isSeparate={true} />} />
            <Route path='/Taba/TeurInfo' element={<TeurInfo isSeparate={true} />} />
            <Route path='/Taba/LocationInfo' element={<LocationInfo isSeparate={true} />} />
            <Route path='/Taba/HavotDaatInfo' element={<HavotDaatInfo isSeparate={true} />} />
            <Route path='/Taba/YahasTohnitInfo' element={<YahasTohnitInfo isSeparate={true} />} />
            {/* Heytel */}
            <Route path='/Heytel/ProcessInfo' element={<ProcessHeytelInfo isSeparate={true} />} />
          </Routes>
          {/* <TestComp /> */}
          {/* <AppFooter /> */}
        </div>
      </Localization>
    </div>
  )
}

export default App
